export default {
  InputEmpty: "Por favor, insira {name}"
} as const;
